import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'W14',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M27.64 17.45h-2.18c-.81 0-1.46-.65-1.46-1.45s.65-1.45 1.45-1.45h2.18a1.451 1.451 0 0 0 0-2.9 1.451 1.451 0 0 1 0-2.9c.1 0 .2.01.29.03 2.28.13 4.08 2 4.08 4.31 0 2.41-1.95 4.36-4.36 4.36zm-7.28-2.9h-16a1.451 1.451 0 0 0 0 2.9h16c2.41 0 4.36 1.95 4.36 4.36 0 2.31-1.8 4.18-4.07 4.33a1.451 1.451 0 1 1-.29-2.87 1.451 1.451 0 0 0 0-2.9h-16A4.372 4.372 0 0 1 0 16c0-2.31 1.8-4.18 4.07-4.33.1-.02.19-.03.29-.03h16a1.451 1.451 0 0 0 0-2.9 1.451 1.451 0 0 1 0-2.9c.1 0 .2.01.29.03 2.27.15 4.07 2.02 4.07 4.33.01 2.39-1.95 4.35-4.36 4.35z" }
      })]
    );
  }
};